// Tipuri + metadata pentru notificările pe EVENIMENTE (transacționale + monitorizare).
// Partajate api ↔ web. Logica de randare (subiect/corp HTML) stă în api
// (services/evenimente-registry.ts) — aici doar catalogul, config-ul și metadata.
/** Catalog: metadata per eveniment (categorie/severitate/etichetă). */
export const EVENIMENTE_META = {
    'contract.creat': { categorie: 'contracte', severitate: 'info', eticheta: 'Contract creat' },
    'contract.predat': { categorie: 'contracte', severitate: 'info', eticheta: 'Predare echipament' },
    'contract.prelungit': { categorie: 'contracte', severitate: 'info', eticheta: 'Prelungire contract' },
    'contract.restituit': { categorie: 'contracte', severitate: 'info', eticheta: 'Restituire echipament' },
    'contract.finalizat': { categorie: 'contracte', severitate: 'info', eticheta: 'Contract finalizat' },
    'contract.retur_cu_daune': { categorie: 'contracte', severitate: 'alert', eticheta: 'Retur cu daune / diferență' },
    'contract.taxa_supl': { categorie: 'contracte', severitate: 'alert', eticheta: 'Taxă suplimentară aplicată' },
    'contract.reziliat': { categorie: 'contracte', severitate: 'alert', eticheta: 'Contract reziliat' },
    'contract.anulat': { categorie: 'contracte', severitate: 'alert', eticheta: 'Contract anulat' },
    'contract.expirat_neretur': { categorie: 'contracte', severitate: 'alert', eticheta: 'Contract expirat — echipament nereturnat' },
    'garantie.restituita': { categorie: 'contracte', severitate: 'info', eticheta: 'Garanție restituită' },
    'contract_cadru.creat': { categorie: 'contracte', severitate: 'info', eticheta: 'Contract-cadru nou' },
    'document.semnat': { categorie: 'documente', severitate: 'info', eticheta: 'Document semnat' },
    'client.creat': { categorie: 'clienti', severitate: 'info', eticheta: 'Client nou' },
    'client.date_modificate': { categorie: 'clienti', severitate: 'alert', eticheta: 'Modificare date sensibile client' },
    'client.ci_expira': { categorie: 'clienti', severitate: 'alert', eticheta: 'CI client expiră' },
    'client.sters_anonimizat': { categorie: 'clienti', severitate: 'alert', eticheta: 'Client șters / anonimizat' },
    'plata.inregistrata': { categorie: 'plati', severitate: 'info', eticheta: 'Plată înregistrată' },
    'plata.refund': { categorie: 'plati', severitate: 'alert', eticheta: 'Rambursare plată' },
    'factura.emisa': { categorie: 'facturare', severitate: 'info', eticheta: 'Factură emisă' },
    'factura.achitata': { categorie: 'facturare', severitate: 'info', eticheta: 'Factură achitată' },
    'factura.scadenta': { categorie: 'facturare', severitate: 'alert', eticheta: 'Factură scadentă' },
    'factura.stornata': { categorie: 'facturare', severitate: 'alert', eticheta: 'Factură stornată' },
    'proforma.emisa': { categorie: 'facturare', severitate: 'info', eticheta: 'Proformă emisă' },
    'factura.taxa_supl': { categorie: 'facturare', severitate: 'alert', eticheta: 'Factură taxă suplimentară' },
    'factura_primita.noua': { categorie: 'facturare', severitate: 'info', eticheta: 'Factură primită (furnizor)' },
    'serie.aproape_epuizata': { categorie: 'facturare', severitate: 'alert', eticheta: 'Serie documente aproape epuizată' },
    'efactura.trimisa': { categorie: 'efactura', severitate: 'info', eticheta: 'e-Factura trimisă la SPV' },
    'efactura.validata': { categorie: 'efactura', severitate: 'info', eticheta: 'e-Factura validată ANAF' },
    'efactura.respinsa': { categorie: 'efactura', severitate: 'critic', eticheta: 'e-Factura RESPINSĂ de ANAF' },
    'efactura.termen_apropiat': { categorie: 'efactura', severitate: 'alert', eticheta: 'Termen SPV apropiat (netrimisă)' },
    'efactura.blocata': { categorie: 'efactura', severitate: 'alert', eticheta: 'e-Factura blocată la trimitere' },
    'anaf.token_expira': { categorie: 'efactura', severitate: 'critic', eticheta: 'Token ANAF expiră curând' },
    'mentenanta.scadenta': { categorie: 'echipamente', severitate: 'alert', eticheta: 'Mentenanță scadentă' },
    'mentenanta.finalizata': { categorie: 'echipamente', severitate: 'info', eticheta: 'Mentenanță finalizată' },
    'echipament.defect': { categorie: 'echipamente', severitate: 'alert', eticheta: 'Echipament defect / scos din uz' },
    'echipament.creat': { categorie: 'echipamente', severitate: 'info', eticheta: 'Echipament nou adăugat' },
    'stoc.scazut': { categorie: 'echipamente', severitate: 'alert', eticheta: 'Stoc consumabil scăzut' },
    'transfer.efectuat': { categorie: 'echipamente', severitate: 'info', eticheta: 'Transfer între puncte de lucru' },
    'rezervare.creata': { categorie: 'rezervari', severitate: 'info', eticheta: 'Rezervare creată' },
    'rezervare.confirmata': { categorie: 'rezervari', severitate: 'info', eticheta: 'Rezervare confirmată' },
    'rezervare.convertita': { categorie: 'rezervari', severitate: 'info', eticheta: 'Rezervare convertită în contract' },
    'rezervare.anulata': { categorie: 'rezervari', severitate: 'alert', eticheta: 'Rezervare anulată' },
    'rezervare.expirata': { categorie: 'rezervari', severitate: 'alert', eticheta: 'Rezervare expirată / no-show' },
    'utilizator.creat': { categorie: 'utilizatori', severitate: 'info', eticheta: 'Utilizator nou' },
    'utilizator.rol_schimbat': { categorie: 'utilizatori', severitate: 'alert', eticheta: 'Schimbare rol utilizator' },
    'utilizator.dezactivat': { categorie: 'utilizatori', severitate: 'alert', eticheta: 'Utilizator dezactivat' },
    'utilizator.parola_resetata': { categorie: 'utilizatori', severitate: 'alert', eticheta: 'Parolă resetată de administrator' },
    'login.brute_force': { categorie: 'utilizatori', severitate: 'critic', eticheta: 'Autentificări eșuate repetate' },
    'setari.sensibile_modificate': { categorie: 'utilizatori', severitate: 'alert', eticheta: 'Modificare setări sensibile' },
    'login.dispozitiv_nou': { categorie: 'utilizatori', severitate: 'alert', eticheta: 'Autentificare de pe dispozitiv nou' },
    'agent.offline': { categorie: 'sistem', severitate: 'critic', eticheta: 'Agent hardware offline' },
    'backup.esuat': { categorie: 'sistem', severitate: 'critic', eticheta: 'Backup DB eșuat' },
    'provider.efactura_cazut': { categorie: 'sistem', severitate: 'alert', eticheta: 'Provider e-Factura indisponibil' },
};
export const CATEGORII = [
    { cheie: 'contracte', eticheta: 'Contracte / închirieri' },
    { cheie: 'documente', eticheta: 'Documente semnate' },
    { cheie: 'clienti', eticheta: 'Clienți' },
    { cheie: 'plati', eticheta: 'Plăți' },
    { cheie: 'facturare', eticheta: 'Facturare' },
    { cheie: 'efactura', eticheta: 'e-Factura / ANAF' },
    { cheie: 'echipamente', eticheta: 'Echipamente / inventar' },
    { cheie: 'rezervari', eticheta: 'Rezervări' },
    { cheie: 'utilizatori', eticheta: 'Utilizatori / securitate' },
    { cheie: 'sistem', eticheta: 'Sistem / operațional' },
];
const CATEGORII_TOATE = (val) => CATEGORII.reduce((acc, c) => { acc[c.cheie] = val; return acc; }, {});
export const EVENIMENTE_CONFIG_DEFAULT = {
    activ: false, // inert până când adminul activează
    categorii: CATEGORII_TOATE(true), // când se activează, toate categoriile pornesc; pot fi ajustate
    perEveniment: {}, // fără override individual (urmează categoria)
    roluriInterne: ['admin'],
    clientOptIn: {},
    oreLiniste: null,
};
/** Normalizează un config parțial la unul complet (merge peste default). */
export function normalizeazaEvenimenteConfig(partial) {
    return {
        activ: partial?.activ ?? EVENIMENTE_CONFIG_DEFAULT.activ,
        categorii: { ...CATEGORII_TOATE(true), ...(partial?.categorii ?? {}) },
        perEveniment: partial?.perEveniment ?? {},
        roluriInterne: Array.isArray(partial?.roluriInterne) ? partial.roluriInterne : [...EVENIMENTE_CONFIG_DEFAULT.roluriInterne],
        clientOptIn: partial?.clientOptIn ?? {},
        oreLiniste: partial?.oreLiniste ?? null,
    };
}
/**
 * Un eveniment trece de filtrul de config?
 * Comutator general → categoria pornită (comutator de grup) → bifa individuală nu e opt-out.
 */
export function evenimentPermis(config, slug) {
    if (!config.activ)
        return false;
    const meta = EVENIMENTE_META[slug];
    if (!meta)
        return false;
    // Evenimentele CRITICE (backup eșuat, e-factura respinsă, token ANAF, brute-force…) NU
    // pot fi suprimate accidental prin debifarea categoriei/acțiunii — sunt alerte de siguranță.
    if (meta.severitate === 'critic')
        return true;
    if (config.categorii[meta.categorie] === false)
        return false;
    return config.perEveniment?.[slug] !== false;
}
//# sourceMappingURL=evenimente.js.map